import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { extractClientMatterNumbers } from '@repo/utils/clientMatterNumbers'

const initialState = {
  accountControlBalances: {},
  matterWorkspace: false,
  clientMatterNo: null
}

export const useAccountControlStore = storeWrapper('useAccountControlStore', (set) => ({
  ...initialState,
  fetchAccountControlBalances: async ({ clientMatterNo, matterWorkspace }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchMatterAccountControl_${clientMatterNo}`,
        delay: 500,
        callback: async () => {
          const { clientNo, matterNo } = extractClientMatterNumbers({ clientMatterNo })
          const service = 'matters'
          const endpoint = matterWorkspace ? 'Matter/GetAccountControlBalances' : 'Client/GetAccountControlBalances'
          const data = matterWorkspace ? { ClientNo: clientNo, MatterNo: matterNo } : { clientNo: clientNo }

          let fetchedAccountControl

          try {
            fetchedAccountControl =
              (await ospreyAPI({
                service: service,
                endpoint: endpoint,
                data: data
              })) || {}
          } catch (err) {
            console.log('Error:', err)
            return
          }

          set({ accountControlBalances: fetchedAccountControl })
          resolve(fetchedAccountControl)
        }
      })
    })
  },
  reset: () => set(initialState)
}))
